import Vue from "vue";

Vue.component("trade-concern-static-content", {
	props: ["type", "language"],
	data() {
		return {
			content: "",
			loading: true
		};
	},
	computed: {
		loadingText() {
			return window.labels.loading + "..";
		},
	},
	methods: {
		getContent: function () {
			this.loading = true;
			this.$services.tradeConcerns.getTradeConcernStaticContent({
				type: this.type,
				language: this.language
			})
				.then((data) => {
					this.loading = false;
					this.content = data.content;
				});
		}
	},
	mounted() {
		this.getContent();
	},
	template: `		
		<div>
			<template v-if="loading">
				<loading :loading-text="loadingText"></loading>
			</template>
			<template v-else>
				<p v-html="content"></p>
			</template>
		</div>
	`
});